import React from "react"
import { Container, Row, Col } from "reactstrap"

import Animate from "../animate"

const list = [
  {
    title: "Ликвидация компании без налоговых рисков"
  },
  {
    title: "Избавление от общения с кредиторами"
  },
  {
    title: "Списание задолженности"
  }
]

const AboutSection = ({ title }) => {
  return (
    <section className="section section--white section_about" id="about">
      <Container>
        <Animate className="slide-up delay-4">
          <div className="section_about__inner">
            <h3 className="section_title">{title}</h3>
            <p className="lead">
              Когда необходимо законно закрыть компанию, когда в бизнесе сложная
              финансовая ситуация, а также для того, чтобы избежать возможных
              налоговых рисков при добровольной ликвидации. Мы помогаем законно
              сохранить имущество и избежать дополнительной ответственности.
            </p>

            <div className="list list--light">
              <Row>
                {list.map((item, i) => (
                  <Col xs={12} md={4} key={i}>
                    <div className="list_item">
                      <div className="list_item__counter">0{i + 1}</div>
                      <h4 className="list_item__title">{item.title}</h4>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </div>
        </Animate>
      </Container>
    </section>
  )
}

export default AboutSection
